export const maritalStatusList = [
  'Solteiro(a)',
  'Casado(a)',
  'Divorciado(a)',
  'Viúvo(a)',
  'Desquitado(a)',
  'União Estável',
  'Outros',
];
